import React from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import ChevronRight from "../common/icons/ChevronRight";

type $Props = {
  handleNext: method,
};

const GalleryNext = ({ classes, className, handleNext }: $Props) => (
  <button onClick={handleNext} className={classNames(classes.root, className)}>
    <ChevronRight style={{ marginLeft: "4px" }} width={32} height={28} />
  </button>
);

export default withStyles((theme) => ({
  root: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    right: "10px",
    width: "44px",
    height: "44px",
    color: "white",
    padding: theme.spacing.unit * 0.5,
    background: "rgba(0,0,0,0.4)",
    borderRadius: theme.globalBorderRadius,
    top: "calc(50% - 36px)",

    [theme.breakpoints(900)]: {
      top: "calc(50% - 111px)",
    },
  },
}))(GalleryNext);
